export const map = fn => v => v.map(fn);

export const sort = fn => v => v.sort(fn);

export const firstChar = str => str.charAt(0);

export const toLowerCase = str => str.toLowerCase();

export const isNonEmptyString = maybeString =>
  typeof maybeString === "string" && maybeString.length > 0;
